import ReactMarkdown from "react-markdown";

export function CheckoutMarkdown({ markdown }: { markdown: string }) {
  return (
    <div className="text-sm mt-1.5 max-w-prose opacity-90 [&_p]:mb-2 [&_p:last-child]:mb-0 [&_ul]:my-1.5 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-1.5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:underline [&_code]:rounded-sm [&_code]:bg-black/10 [&_code]:px-1 [&_code]:py-0.5 [&_strong]:font-semibold">
      <ReactMarkdown>{markdown}</ReactMarkdown>
    </div>
  );
}
